// Gauge-related constants extracted for better organization and reuse
export const V_SPEEDS = [
  {
    speed: 47,
    label: "Vso",
    color: "#E12C2C",
    description: "Stall Speed in Landing Configuration",
  },
  {
    speed: 50,
    label: "Vs",
    color: "#E12C2C",
    description: "Stall Speed in Clean Configuration",
  },
  {
    speed: 64,
    label: "Vx",
    color: "#2D9B2B",
    description: "Best Angle of Climb",
  },
  {
    speed: 76,
    label: "Vy",
    color: "#2D9B2B",
    description: "Best Rate of Climb",
  },
  {
    speed: 112,
    label: "Va",
    color: "#2D9B2B",
    description: "Maneuvering Speed",
  },
  {
    speed: 121,
    label: "Vno",
    color: "#FFD700",
    description: "Maximum Structural Cruising Speed",
  },
  {
    speed: 148,
    label: "Vne",
    color: "#E12C2C",
    description: "Never Exceed Speed",
  },
];

export const ARC_CONFIG = {
  white: { start: 48, end: 100, color: "#ffffff" }, // Flap operating range
  green: { start: 56, end: 121, color: "#2D9B2B" }, // Normal operating range
  yellow: { start: 121, end: 148, color: "#FFD700" }, // Caution range
  red: { start: 148, end: 150, color: "#E12C2C" }, // Danger zone
};

export const GAUGE_CONFIG = {
  minSpeed: 20,
  maxSpeed: 150,
  greenArcStart: 55,
  greenArcEnd: 120,
  yellowArcStart: 120,
  yellowArcEnd: 145,
  redLineSpeed: 145,
  radius: 140,
  centerX: 160,
  centerY: 160,
};

export const SPEED_COLOR_CONFIG = {
  white: { start: 0, end: 56, color: "#ffffff" },
  green: { start: 56, end: 121, color: "#2D9B2B" },
  yellow: { start: 121, end: 148, color: "#FFD700" },
  red: { start: 148, end: 150, color: "#E12C2C" },
};
